import * as React from 'react';

import * as TypeStyle from 'typestyle';
import { TabStyles } from '../styles/TabStyles';

/**
 * The sub-components for progress bars. Compose these to form different types of progress bars.
 */

/**
 * Outermost container. Must specify a width so animation knows its limits.
 */
export interface ProgressBarContainerProps {
  children?: React.ReactNode;
  width: number;
}
const getProgressBarContainerStyle: () => React.CSSProperties = () => {
  return {
    backgroundColor: TabStyles.Colors.F3,
    borderRadius: TabStyles.Sizing.BorderRadius,
    height: TabStyles.Sizing.BaseUnit,
    position: 'relative',
  };
};
export const ProgressBarContainer: React.FunctionComponent<ProgressBarContainerProps> = (props: ProgressBarContainerProps) => {
  const style: React.CSSProperties = { ...getProgressBarContainerStyle(), width: props.width };
  return <div style={style} children={props.children} />;
};

/**
 * The amount of progress completed. Fills height of its container.
 */
export interface ProgressCompleteBarProps {
  children?: React.ReactNode;
  fractionComplete: number;
}
const getProgressBarStyle: () => React.CSSProperties = () => {
  return {
    backgroundColor: TabStyles.Colors.GoLight,
    height: '100%',
    left: 0,
    position: 'absolute',
    top: 0,
  };
};
export const ProgressCompleteBar: React.FunctionComponent<ProgressCompleteBarProps> = (props: ProgressCompleteBarProps) => {
  const style: React.CSSProperties = { ...getProgressBarStyle(), width: `${100 * props.fractionComplete}%` };
  return <div style={style} children={props.children} />;
};

/**
 * The cute animation
 */
export interface ProgressBarAnimationProps {
  containerWidth: number;
}
const getProgressBarAnimationWidth = () => TabStyles.Sizing.BaseUnit;
const getProgressBarAnimationStaticStyle: () => React.CSSProperties = () => {
  return {
    backgroundColor: TabStyles.Colors.GoDark,
    height: '100%',
    position: 'absolute',
    top: 0,
    width: getProgressBarAnimationWidth(),
  };
};
export const ProgressBarAnimation: React.FunctionComponent<ProgressBarAnimationProps> = ({ containerWidth }: ProgressBarAnimationProps) => {
  const animationClassName = TypeStyle.style({
    animationDirection: 'alternate',
    animationDuration: '1000ms',
    animationIterationCount: 'infinite',
    animationName: TypeStyle.keyframes({
      '0%': { transform: `translate3d(0px, 0px, 0px)` },
      '100%': { transform: `translate3d(${containerWidth - getProgressBarAnimationWidth()}px, 0px, 0px)` },
    }),
    animationTimingFunction: 'ease-in-out',
  });

  return <div
    className={animationClassName}
    style={getProgressBarAnimationStaticStyle()}
  />;
};
